import React, { useState } from 'react';
import { Pressable, ScrollView, VStack } from 'native-base';
import { Caption } from '~/shared/Typography';
import { ShopHeader } from './components/ShopHeader';
import Section from '~/shared/Section';
import { BrandsList } from './components/BrandsList';
import { ProductList } from './components/ProductList';
import { PromotionCarousel } from './components/PromotionCarousel';
import { useShopStyles } from '~/shared/styles';
import { useAppNavigate } from '~/pages';
import { CategoriesList } from '~/pages/shop/components/CategoriesList';
import { ActiveFiltersList } from '~/pages/shop/components/ActiveFiltersList';
import { useDutchieStore, useI18n, defaultCategories } from '@springbig/shared';

export const ShopPage = () => {

    const {
        filters,
        sortByProp,
        cartItemsAmount,
        isBusy,
    } = useDutchieStore();
    const {
        button_background,
        button_text,
    } = useShopStyles();
    const { navigate, params } = useAppNavigate();
    const { t } = useI18n();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const hasFiltersEnabled = !!filters?.strainType || filters?.effects?.length > 0 || (filters?.minPrice || filters?.maxPrice);

    return (
        <Section flex={1}>
            <ScrollView scrollEnabled={!isDrawerOpen} flex={1} pb={cartItemsAmount ? 20 : 0}>
                <VStack space={2}>
                    <ShopHeader isDrawerOpen={isDrawerOpen} setIsDrawerOpen={(value) => setIsDrawerOpen(value)} />
                    <CategoriesList />
                    <PromotionCarousel />
                    <BrandsList />
                    { hasFiltersEnabled ? <ActiveFiltersList t={t} /> : <></>}
                    { filters?.categories ? defaultCategories.filter((e) => filters?.categories?.includes(e?.category))?.map((e, index) =>

                        <ProductList
                            key={index} {...e}
                            effect={filters?.effects}
                            strain={filters?.strainType}
                            menuSort={sortByProp?.menuSort}
                        />
                    ) : defaultCategories?.map((e, index) =>

                        <ProductList
                            key={index} {...e}
                            effect={filters?.effects}
                            strain={filters?.strainType}
                            menuSort={sortByProp?.menuSort}
                        />
                    )}
                </VStack>
            </ScrollView>
            { cartItemsAmount ?
                <Pressable
                    position={'fixed'}
                    bottom={24}
                    bg={button_background}
                    rounded={'2xl'}
                    py={5}
                    alignSelf={'center'}
                    w={'clamp(320px, 90vw, 450px)'}
                    opacity={isBusy ? .7 : 1}
                    textAlign={'center'}
                    isDisabled={isBusy}
                    onPress={() => navigate(`w/${params.wallet_id}/shop/cart`)}
                >
                    <Caption color={button_text}>
                        { t('shop.view_cart') } ({ cartItemsAmount })
                    </Caption>
                </Pressable>
                :
                <></>
            }
        </Section>
    );
};